import React from "react";
import { Modal } from "antd";
import CrmCallHistoryForm from "./CrmCallHistoryForm";
import { useGeneralStore } from "../../../../store/slices/createGeneralSlice";

function CrmCallModal({ usrUserID, requestId, detailsCall }) {

    const general = useGeneralStore()
    const visible = general.view.crmCallModal;

    return (
        <div>
            <Modal
                width={800}
                title={"تماس جدید"}
                className="custom-table crm-request-report"
                open={visible}
                footer={false}
                onCancel={() => general.ToggleCrmCallModal(false)}
            >
                <CrmCallHistoryForm
                    onSubmit={() => {
                        general.ToggleCrmCallModal(true);
                    }}
                    usrUserID={usrUserID}
                    requestId={requestId}
                    detailsCall={detailsCall}
                />
            </Modal>
        </div>
    );
}

export default CrmCallModal
//   مودال در تب درخواست ها - جزئیات بیمه نامه- تب تماس - افزودن تماس جدید نمایش داده می شود